module.exports = __webpack_public_path__ + "static/media/twoColumns.c890ecda.gif";